/**
 * Уведомления логистам (раздел 15.1): портал (колокольчик, /notifications) и Telegram.
 * Типы совпадают с notifications.type в БД.
 */
export const NOTIFICATION_TYPES = [
  "lot_published",
  "first_bid",
  "lot_extended",
  "lot_finished_winner",
  "lot_no_winner",
  "winner_data_received",
  "delivery_reported",
  "payment_due_soon",
  "payment_overdue",
  "chat_message",
  /** Проверка свежести резервной копии (16.7): дампа нет или он старше суток. */
  "backup_stale",
] as const;
export type NotificationType = (typeof NOTIFICATION_TYPES)[number];

export const NOTIFICATION_ICONS: Record<NotificationType, string> = {
  lot_published: "📦",
  first_bid: "💰",
  lot_extended: "⏰",
  lot_finished_winner: "🏆",
  lot_no_winner: "⚪",
  winner_data_received: "📄",
  delivery_reported: "🚚",
  payment_due_soon: "⏳",
  payment_overdue: "❗",
  chat_message: "💬",
  backup_stale: "🛟",
};

export const notificationIcon = (type: string): string => (NOTIFICATION_ICONS as Record<string, string>)[type] ?? "🔔";

/** Строка GET /api/me/notifications. Даты — ISO-строки. */
export type NotificationItem = {
  id: string;
  lotId: string | null;
  lotNumber: string | null;
  type: string;
  title: string;
  body: string;
  readAt: string | null;
  sentTelegramAt: string | null;
  createdAt: string;
};

export type NotificationsResponse = {
  items: NotificationItem[];
  /** Всего непрочитанных у пользователя (не только в выданном списке). */
  unreadCount: number;
};
